import { render, staticRenderFns } from "./HorizontalCoverMockup.vue?vue&type=template&id=20083a74&"
import script from "./HorizontalCoverMockup.vue?vue&type=script&lang=js&"
export * from "./HorizontalCoverMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports